<template>
  <svg
    v-if="dataFound"
    :class="$style.svgBox"
    data-testid="svgBox"
    viewBox="0 0 355 84"
    width="100%"
    height="100%"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      data-testid="chartLines"
      d="M347 79.0957C347 81.3048 345.209 83.0957 343 83.0957C340.791 83.0957 339 81.3048 339 79.0957C339 76.8866 340.791 75.0957 343 75.0957C345.209 75.0957 347 76.8866 347 79.0957Z"
      fill="#B6C9EC"
    />
    <path
      data-testid="chartLines"
      d="M319.417 79.0957C319.417 81.3048 317.626 83.0957 315.417 83.0957C313.208 83.0957 311.417 81.3048 311.417 79.0957L311.417 73.0957C311.417 70.8866 313.208 69.0957 315.417 69.0957C317.626 69.0957 319.417 70.8866 319.417 73.0957L319.417 79.0957Z"
      fill="#B6C9EC"
    />
    <path
      data-testid="chartLines"
      d="M291.833 79.0957C291.833 81.3048 290.042 83.0957 287.833 83.0957C285.624 83.0957 283.833 81.3048 283.833 79.0957L283.833 68.0957C283.833 65.8866 285.624 64.0957 287.833 64.0957C290.042 64.0957 291.833 65.8866 291.833 68.0957L291.833 79.0957Z"
      fill="#B6C9EC"
    />
    <path
      data-testid="chartLines"
      d="M264.25 79.0957C264.25 81.3048 262.459 83.0957 260.25 83.0957C258.041 83.0957 256.25 81.3048 256.25 79.0957L256.25 42.0957C256.25 39.8866 258.041 38.0957 260.25 38.0957C262.459 38.0957 264.25 39.8866 264.25 42.0957L264.25 79.0957Z"
      fill="#688CD2"
    />
    <path
      data-testid="chartLines"
      d="M236.667 79.0957C236.667 81.3048 234.876 83.0957 232.667 83.0957C230.458 83.0957 228.667 81.3048 228.667 79.0957L228.667 18.0957C228.667 15.8866 230.458 14.0957 232.667 14.0957C234.876 14.0957 236.667 15.8866 236.667 18.0957L236.667 79.0957Z"
      fill="#688CD2"
    />
    <path
      data-testid="chartLines"
      d="M209.083 79.0957C209.083 81.3048 207.292 83.0957 205.083 83.0957C202.874 83.0957 201.083 81.3048 201.083 79.0957L201.083 10.0957C201.083 7.88657 202.874 6.0957 205.083 6.0957C207.292 6.0957 209.083 7.88657 209.083 10.0957L209.083 79.0957Z"
      fill="#688CD2"
    />
    <path
      data-testid="chartLines"
      d="M181.5 79.0957C181.5 81.3048 179.709 83.0957 177.5 83.0957C175.291 83.0957 173.5 81.3048 173.5 79.0957L173.5 4.0957C173.5 1.88657 175.291 0.0957026 177.5 0.0957028C179.709 0.095703 181.5 1.88657 181.5 4.0957L181.5 79.0957Z"
      fill="#1E50AD"
    />
    <path
      data-testid="chartLines"
      d="M153.917 79.0957C153.917 81.3048 152.126 83.0957 149.917 83.0957C147.708 83.0957 145.917 81.3048 145.917 79.0957L145.917 10.0957C145.917 7.88657 147.708 6.0957 149.917 6.0957C152.126 6.0957 153.917 7.88657 153.917 10.0957L153.917 79.0957Z"
      fill="#688CD2"
    />
    <path
      data-testid="chartLines"
      d="M126.333 79.0957C126.333 81.3048 124.542 83.0957 122.333 83.0957C120.124 83.0957 118.333 81.3048 118.333 79.0957L118.333 18.0957C118.333 15.8866 120.124 14.0957 122.333 14.0957C124.542 14.0957 126.333 15.8866 126.333 18.0957L126.333 79.0957Z"
      fill="#688CD2"
    />
    <path
      data-testid="chartLines"
      d="M98.75 79.0957C98.75 81.3048 96.9591 83.0957 94.75 83.0957C92.5409 83.0957 90.75 81.3048 90.75 79.0957L90.75 42.0957C90.75 39.8866 92.5409 38.0957 94.75 38.0957C96.9591 38.0957 98.75 39.8866 98.75 42.0957L98.75 79.0957Z"
      fill="#688CD2"
    />
    <path
      data-testid="chartLines"
      d="M71.167 79.0957C71.167 81.3048 69.3761 83.0957 67.167 83.0957C64.9579 83.0957 63.167 81.3048 63.167 79.0957L63.167 68.0957C63.167 65.8866 64.9579 64.0957 67.167 64.0957C69.3761 64.0957 71.167 65.8866 71.167 68.0957L71.167 79.0957Z"
      fill="#B6C9EC"
    />
    <path
      data-testid="chartLines"
      d="M43.583 79.0957C43.583 81.3048 41.7921 83.0957 39.583 83.0957C37.3739 83.0957 35.583 81.3048 35.583 79.0957L35.583 73.0957C35.583 70.8866 37.3739 69.0957 39.583 69.0957C41.7921 69.0957 43.583 70.8866 43.583 73.0957L43.583 79.0957Z"
      fill="#B6C9EC"
    />
    <path
      data-testid="chartLines"
      d="M16 79.0957C16 81.3048 14.2091 83.0957 12 83.0957C9.79086 83.0957 8 81.3048 8 79.0957C8 76.8866 9.79086 75.0957 12 75.0957C14.2091 75.0957 16 76.8866 16 79.0957Z"
      fill="#B6C9EC"
    />
  </svg>
  <span v-else :class="$style.noDataBox" v-html="t('common.noData')"></span>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Props {
  dataFound: boolean;
}
withDefaults(defineProps<Props>(), {
  dataFound: true,
});
</script>
<style lang="scss" module>
@use '@/styles/variables' as *;

.chartCurve {
  stroke: $color-teal-140;
  stroke-width: 2;
}

.chartPolygon {
  fill: var(--theme-color-primary);
}

.svgBox {
  fill: none;
}

.noDataBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: $space-1000;
  margin-top: $space-75;
  color: #808080;
  text-align: center;

  @include body-3;
}
</style>
